<template>
  <div class="base">
    <main-header page_type="revealList" />
    <div class="container">
      <van-search v-model="filterCondition.teacher_id" shape="round" placeholder="请输入教员编号" @search="onSearchTeacher" />
      <div class="filter-conditions">
        <van-dropdown-menu>
          <van-dropdown-item v-model="area" :options="areaOptions" @change="areaChange" />
          <van-dropdown-item v-model="school" :options="schoolOptions" @change="schoolChange" />
          <van-dropdown-item v-model="type" :options="typeOptions" @change="typeChange" />
          <van-dropdown-item v-model="sex" :options="sexOptions" @change="sexChange" />
        </van-dropdown-menu>
      </div>
      <div v-if="teacher_arr.length > 0" class="teacher-list">
        <div v-for="(teacher, index) in teacher_arr" :key="index" class="item">
          <a-row :gutter="8">
            <a-col :span="5" class="header-area">
              <div style="text-align:center;">
                <img :src="teacher.avatar" style="border-radius: 50%" alt="" height="60px" width="60px"
                  @click="goRevealInfo(teacher.id)">
              </div>
            </a-col>
            <a-col :span="19" class="desc-area">
              <div class="name-code">
                <span class="name" @click="goRevealInfo(teacher.id)">{{ teacher.nick_name }}</span>
                <span class="code">T{{ teacher.id }}</span>
                <span v-if="teacher.sex === '女'" style="margin-left: 10px;position: relative;top: 5px;"
                  class="gender-icon" />
                <span v-if="realname_status !== 'null'" style="margin-left: 10px;position: relative;top: 5px;"
                  class="realname-icon" />
                <span v-if="teacher.type === 'full_time'" style="margin-left: 10px;position: relative;top: 5px;"
                  class="fulltime-icon" />
              </div>
              <div class="label-area">
                <span style="display: inline-block;margin-bottom: 10px">{{ teacher.school }}</span>
                <span style="display: inline-block;margin-bottom: 10px">{{ teacher.major }}</span>
                <span style="display: inline-block;margin-bottom: 10px">{{ teacher.highest_edu }}</span>
              </div>
              <div class="introduce">
                <span>{{ teacher.self_evaluation }}</span>
              </div>
              <div class="subject-comment" style="margin-top:15px;">
                <a-row :gutter="8">
                  <a-col class="subject" :span="14">
                    <span v-for="(subject, i) in teacher.teaching_subjects_arr.slice(0, 2)" :key="i">{{ subject
                    }}</span>
                  </a-col>
                  <a-col class="rate-area" :span="10">
                    <a-rate :value="4" size="12px" style="color:coral;font-size: 12px;" />
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <van-empty v-if="teacher_arr.length === 0" description="暂无数据" />
      <div class="pagination">
        <van-pagination v-if="teacher_arr.length > 0" v-model="current_page" :total-items="total_page"
          :show-page-size="3" force-ellipses @change="pageChange" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainHeader, MainFooter } from '@/components'
import store from '@/store/'

export default {
  name: 'Moment',
  components: {
    MainHeader,
    MainFooter
  },
  props: {
    page: {
      default: 1
    },
    area: {
      default: 'all'
    },
    type: {
      default: 'all'
    },
    sex: {
      default: 'all'
    },
    school: {
      default: 'all'
    },
    teacher_id: {
      default: null
    },
    realname_status: null
  },
  data() {
    return {
      loading: true,
      filterCondition: {
        area: this.area,
        type: this.type,
        school: this.school,
        course: 'all',
        sex: this.sex,
        teacher_id: this.teacher_id
      },
      areaOptions: [
        { text: '全部区域', value: 'all' }],
      schoolOptions: [
        { text: '全部学校', value: 'all' }],
      typeOptions: [
        { text: '全部类型', value: 'all' },
        { text: '大学生', value: 'part_time' },
        { text: '专职教师', value: 'full_time' }
      ],
      sexOptions: [
        { text: '不限', value: 'all' },
        { text: '男', value: '男' },
        { text: '女', value: '女' }
      ],
      region: '',
      // data
      teacher_list: {},
      teacher_arr: [],
      region_area: [],
      region_university: [],
      news_list: [],
      help_list: [],
      total_page: null,
      current_page: 1,
      last_page: 1
    }
  },
  computed: {
  },
  watch: {
    // url改变，重新加载数据
    '$route'(to, from) {
      this.loadData(this.page)
    },
    area(val) {
      this.filterCondition.area = val
    },
    type(val) {
      this.filterCondition.type = val
    },
    sex(val) {
      this.filterCondition.sex = val
    },
    school(val) {
      console.log(val)
      this.filterCondition.school = val
    },
    teacher_id(val) {
      this.filterCondition.teacher_id = val
    },
    teacher_list(val) {
      this.teacher_arr = val.data
      this.current_page = val.current_page
      this.total_page = val.total
      this.last_page = val.last_page
    },
    region_area(val) {
      var data = [
        { text: '全部区域', value: 'all' }
      ]
      val.forEach((item) => {
        data.push({
          text: item.name,
          value: item.name
        })
      })
      this.areaOptions = data
    },
    region_university(val) {
      var data = [
        { text: '全部学校', value: 'all' }
      ]
      val.forEach((item) => {
        data.push({
          text: item.name,
          value: item.name
        })
      })
      this.schoolOptions = data
    }
  },
  created() {
    this.region = store.getters.region
    this.loadData()
  },
  methods: {
    loadData(page) {
      this.loading = true
      var queryParam = {}
      queryParam.region = this.region
      const filterCondition = this.filterCondition
      if (filterCondition.area !== 'all') {
        queryParam.area = filterCondition.area
      }
      if (filterCondition.type !== 'all') {
        queryParam.type = filterCondition.type
      }
      if (filterCondition.sex !== 'all') {
        queryParam.sex = filterCondition.sex
      }
      if (filterCondition.school !== 'all') {
        queryParam.school = filterCondition.school
      }
      if (filterCondition.teacher_id !== null) {
        queryParam.teacher_id = filterCondition.teacher_id
      }
      if (page) {
        queryParam.page = page
      }
      this.$http({
        url: '/index/index/teacherShow',
        methods: 'get',
        params: queryParam
      }).then(res => {
        if (res.status === 'success') {
          this.loading = false
          console.log('data ....')
          console.log(res)
          const data = res.data
          this.region = data.region
          this.region_area = data.region_area
          this.region_university = data.region_university
          this.teacher_list = data.teacher_list
          this.news_list = data.news_list
          this.help_list = data.help_list
        }
      })
    },
    onSearchTeacher(value) {
      this.filterCondition.teacher_id = value
      this.$router.push({ name: 'RevealList', query: this.filterCondition })
    },
    pageChange(value) {
      this.filterCondition.page = value
      this.$router.push({ name: 'RevealList', query: this.filterCondition })
    },
    areaChange(value) {
      this.filterCondition.area = value
      this.$router.push({ name: 'RevealList', query: this.filterCondition })
    },
    schoolChange(value) {
      this.filterCondition.school = value
      this.$router.push({ name: 'RevealList', query: this.filterCondition })
    },
    typeChange(value) {
      this.filterCondition.type = value
      this.$router.push({ name: 'RevealList', query: this.filterCondition })
    },
    sexChange(value) {
      this.filterCondition.sex = value
      this.$router.push({ name: 'RevealList', query: this.filterCondition })
    },
    goRevealInfo(teacherId) {
      console.log(teacherId)
      this.$router.push({ name: 'RevealInfo', params: { id: teacherId } })
    }
  }
}
</script>
<style lang="stylus">
    .base {
        min-width: 280px;
        max-width: 420px;
        margin: auto;
        background-color: #fff;
    }

    .container {
        padding: 0 15px;
    }

    .search-area {
        input {
            background-color: #f5f5f5;
        }
    }

    .filter-conditions {
        .van-dropdown-menu__bar {
            box-shadow: none;
        }
    }

    .teacher-list {
        margin-top: 20px;

        .item {
            box-shadow: 0px 0px 10px 0px rgba(216, 216, 216, 0.3);
            margin-bottom: 15px;
            padding: 16px 18px 18px 15px;

            .header-area {

                .show-icon-area {
                    margin-top: 20px;
                    display: inline-block;
                    // height: 24px;
                    // margin-left: 10px;

                    div {
                        margin-left: 5px;
                    }
                }
            }

            .desc-area {

                .name-code {
                    .name {
                        font-family: PingFang-SC-Bold;
                        font-size: 15px;
                        line-height: 16px;
                        letter-spacing: 0px;
                        font-weight: bold;
                        color: #333333;
                    }

                    .code {
                        font-family: PingFang-SC-Bold;
                        font-size: 15px;
                        font-weight: normal;
                        letter-spacing: 0px;
                        color: #ff5c00;
                        font-weight: bold;

                        margin-left:28px;
                    }
                }

                .label-area {
                    margin-top: 5px;

                    span {
                        font-size: 11px;
                        padding: 5px;
                        background-color: #f2f4f4;
                        border-radius: 5px;
                        color: #666666;

                        margin-right: 7px;
                    }
                }

                .introduce {
                    margin-top: 10px;

                    span {
                        font-family: PingFang-SC-Regular;
                        font-size: 14px;
                        line-height: 16px;
                        letter-spacing: 0px;
                        color: #333333;
                    }
                }

                .subject-comment {

                    .subject {
                        font-family: PingFang-SC-Regular;
                        font-size: 11px;
                        line-height: 19px;
                        letter-spacing: 0px;
                        color: #666666;

                        span {
                            margin-right: 5px;
                        }
                    }
                }

            }

        }

    }

    .van-pagination__item--active {
        color: #fff;
        background-color: #ff5c00;
    }
</style>
